import { Plugin } from 'prosemirror-state';
import { imageNodeName } from '../../../extensions/markdown';
import { reactNodeViewFactory } from '../../../react-utils/react-node-view';
import { ImagePaste } from './ImagePaste';
import { ImageWidget } from './ImageWidget';
import { ImageNodeView, cnImgSizeNodeView } from './NodeView/NodeView';
import { imageRendererKey } from './const';
export const ImgSizeAdditions = (builder, opts) => {
    builder.use(ImageWidget, {
        imageUploadHandler: opts.imageUploadHandler,
        needToSetDimensionsForUploadedImages: Boolean(opts.needToSetDimensionsForUploadedImages),
    });
    if (opts.imageUploadHandler) {
        builder.use(ImagePaste, {
            imageUploadHandler: opts.imageUploadHandler,
            needDimmensions: Boolean(opts.needToSetDimensionsForUploadedImages),
        });
    }
    builder.addPlugin((deps) => new Plugin({
        key: imageRendererKey,
        state: {
            init: () => undefined,
            apply: (tr) => {
                return tr.getMeta(imageRendererKey);
            },
        },
        props: {
            nodeViews: {
                [imageNodeName]: reactNodeViewFactory(ImageNodeView, {
                    isInline: true,
                    reactNodeWrapperCn: cnImgSizeNodeView('wrapper'),
                })(deps),
            },
        },
    }));
};
